/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_UnitInputs */

const vi_packaging_material_unit = /** @type {(inputs: Packaging_Material_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn vị`)
};

/**

* @param {Packaging_Material_UnitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_unit = /** @type {((inputs?: Packaging_Material_UnitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_UnitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_unit(inputs)
});